import axios from "axios";
import { base_url } from "../../utils/baseUrl";



const getAdvertisements = async () => {
  
  const response = await axios.get(`${base_url}ads/getAllAds`);
 
  return response.data;
  
};
const createAdvertisement = async (values) => {
  const response = await axios.post(`${base_url}ads/createAd`,values);

  return response.data;
};

const updateAdvertisement = async (values) => {
  const id = values.get("id") 
  const response = await axios.put(
    `${base_url}ads/updateAd/${id}`,
    values,

  );

  return response.data;
};

const getAdvertisement = async (id) => {
  const response = await axios.get(`${base_url}ads/getById/${id}`);

  return response.data;
};

const deleteAdvertisement = async (id) => {
  const response = await axios.delete(`${base_url}ads/deleteAd/${id}`);

  return response.data;
};
const AdvertisementService = {
  getAdvertisements,
  createAdvertisement,
  getAdvertisement,
  updateAdvertisement,
  deleteAdvertisement,
};

export default AdvertisementService;
